import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5359ccbc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "payment-container" }
const _hoisted_2 = { class: "payment-overview-block-wrapper flex-wrapper flex-height" }
const _hoisted_3 = { class: "payment-overview-block" }
const _hoisted_4 = { class: "payment-search-wrapper" }
const _hoisted_5 = { class: "payment-search-row" }
const _hoisted_6 = { class: "search-item" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label" }, " 任务期间 ", -1))
const _hoisted_8 = { class: "search-item" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label" }, " 任务名称 ", -1))
const _hoisted_10 = { class: "search-item" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label" }, " 任务种类 ", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "search-item" }, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "search-item" }, null, -1))
const _hoisted_14 = { class: "search-btn" }
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" 查询 ")
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" 导出查询结果 ")
const _hoisted_17 = {
  class: "payment-overview-block flex-wrapper flex-height",
  style: {"margin-top":"10px"}
}
const _hoisted_18 = /*#__PURE__*/_createTextVNode("添加反馈")
const _hoisted_19 = /*#__PURE__*/_createTextVNode("无要求")
const _hoisted_20 = /*#__PURE__*/_createTextVNode("查看")
const _hoisted_21 = /*#__PURE__*/_createTextVNode("修改反馈")
const _hoisted_22 = /*#__PURE__*/_createTextVNode("添加反馈")
const _hoisted_23 = { class: "operation" }
const _hoisted_24 = ["onClick"]
const _hoisted_25 = { class: "btns-wrapper" }
const _hoisted_26 = /*#__PURE__*/_createTextVNode("保存")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Breadcrumb = _resolveComponent("Breadcrumb")!
  const _component_a_range_picker = _resolveComponent("a-range-picker")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_table_wrapper = _resolveComponent("table-wrapper")!
  const _component_a_modal = _resolveComponent("a-modal")!
  const _component_a_textarea = _resolveComponent("a-textarea")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_Breadcrumb, { dataSource: [] }),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _hoisted_7,
                _createVNode(_component_a_range_picker, {
                  allowClear: "",
                  value: _ctx.taskPeriod,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.taskPeriod) = $event)),
                  placeholder: ['开始日期', '截止日期'],
                  format: _ctx.dateFormat
                }, null, 8, ["value", "format"])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _hoisted_9,
                _createVNode(_component_a_input, {
                  placeholder: "请输入",
                  value: _ctx.query.taskNameCn,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.query.taskNameCn) = $event)),
                  allowClear: ""
                }, null, 8, ["value"])
              ]),
              _createElementVNode("div", _hoisted_10, [
                _hoisted_11,
                _createVNode(_component_a_select, {
                  value: _ctx.query.category,
                  "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.query.category) = $event)),
                  class: "sel-inp-size",
                  placeholder: "Please select"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categoryList, (item) => {
                      return (_openBlock(), _createBlock(_component_a_select_option, {
                        value: item.value,
                        key: item.value
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.name), 1)
                        ]),
                        _: 2
                      }, 1032, ["value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _hoisted_12,
              _hoisted_13
            ]),
            _createElementVNode("div", _hoisted_14, [
              (_ctx.$btnPermissions('RV DataDoc Search'))
                ? (_openBlock(), _createBlock(_component_a_button, {
                    key: 0,
                    type: "primary",
                    class: "m-r-15",
                    onClick: _ctx.search
                  }, {
                    default: _withCtx(() => [
                      _hoisted_15
                    ]),
                    _: 1
                  }, 8, ["onClick"]))
                : _createCommentVNode("", true),
              (_ctx.$btnPermissions('RV DataDoc Export'))
                ? (_openBlock(), _createBlock(_component_a_button, {
                    key: 1,
                    onClick: _ctx.exportQueryResult
                  }, {
                    default: _withCtx(() => [
                      _hoisted_16
                    ]),
                    _: 1
                  }, 8, ["onClick"]))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_17, [
          _createVNode(_component_table_wrapper, { "is-pagination": _ctx.isPagination }, {
            default: _withCtx((slotProps) => [
              _createVNode(_component_a_table, {
                scroll: { y: slotProps.tableHeight, x: 1600 },
                dataSource: _ctx.data,
                columns: _ctx.column,
                rowKey: "id",
                pagination: false,
                rowClassName: 
                (record, index) => (index % 2 === 1 ? 'table-striped' : null)
              
              }, {
                feedback: _withCtx(({ record }) => [
                  (record.feedbackDealer === '5' && _ctx.$btnPermissions('RV DataDoc Feedback'))
                    ? (_openBlock(), _createBlock(_component_a_button, {
                        key: 0,
                        type: "link",
                        block: "",
                        onClick: _ctx.handleForbidAddFeedback
                      }, {
                        default: _withCtx(() => [
                          _hoisted_18
                        ]),
                        _: 1
                      }, 8, ["onClick"]))
                    : _createCommentVNode("", true),
                  (record.feedbackDealer === '4')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _hoisted_19
                      ], 64))
                    : _createCommentVNode("", true),
                  (record.feedbackDealer === '3' && _ctx.$btnPermissions('RV DataDoc View'))
                    ? (_openBlock(), _createBlock(_component_a_button, {
                        key: 2,
                        type: "link",
                        block: "",
                        onClick: ($event: any) => (_ctx.handleViewFeedback(record))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_20
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                    : _createCommentVNode("", true),
                  (record.feedbackDealer === '2' && _ctx.$btnPermissions('RV DataDoc Edit'))
                    ? (_openBlock(), _createBlock(_component_a_button, {
                        key: 3,
                        type: "link",
                        block: "",
                        onClick: ($event: any) => (_ctx.handleToEditFeedback(record))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_21
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                    : _createCommentVNode("", true),
                  (record.feedbackDealer === '1' && _ctx.$btnPermissions('RV DataDoc Feedback'))
                    ? (_openBlock(), _createBlock(_component_a_button, {
                        key: 4,
                        type: "link",
                        block: "",
                        onClick: ($event: any) => (_ctx.handleToAddFeedback(record))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_22
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                    : _createCommentVNode("", true)
                ]),
                operation: _withCtx(({ record }) => [
                  _createElementVNode("div", _hoisted_23, [
                    (_ctx.$btnPermissions('RV DataDoc Download'))
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 0,
                          class: "link",
                          onClick: ($event: any) => (_ctx.handleExport(record))
                        }, "下载", 8, _hoisted_24))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _: 2
              }, 1032, ["scroll", "dataSource", "columns", "rowClassName"])
            ]),
            _: 1
          }, 8, ["is-pagination"])
        ])
      ])
    ]),
    _createVNode(_component_a_modal, {
      visible: _ctx.feadbackModalvisible,
      "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.feadbackModalvisible) = $event)),
      title: "经销商反馈",
      footer: null
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.feadbackModalContent), 1)
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_a_modal, {
      class: "split-task-feedback-editor-dialog",
      visible: _ctx.feedbackEditorModalVisible,
      "onUpdate:visible": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.feedbackEditorModalVisible) = $event)),
      title: "编辑内容",
      footer: null
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_textarea, {
          value: _ctx.feedbackEditorModalContent,
          "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.feedbackEditorModalContent) = $event)),
          placeholder: "请输入",
          "auto-size": { minRows: 5, maxRows: 5 },
          maxlength: 2000,
          showCount: ""
        }, null, 8, ["value"]),
        _createElementVNode("div", _hoisted_25, [
          _createVNode(_component_a_button, {
            type: "primary",
            onClick: _ctx.handleSaveFeedback
          }, {
            default: _withCtx(() => [
              _hoisted_26
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}